import { render } from "./Page404.vue?vue&type=template&id=4fe147c1&scoped=true"
import script from "./Page404.vue?vue&type=script&lang=js"
export * from "./Page404.vue?vue&type=script&lang=js"

import "./Page404.vue?vue&type=style&index=0&id=4fe147c1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe147c1"]])

export default __exports__